App.SmSlideableComponent = Em.Component.extend
  classNames: [ 'sm-slideable' ]

  classNameBindings: [
    'currentSlideClass',
    'slidesCountClass'
  ]

  sectionsStyle: (->
    idx  = @get('currentSlideIndex')
    size = @get('slides.length')

    return ''.htmlSafe() if size is 0

    shift = -(idx * 100) / size

    """
    -webkit-transform: translate3d(#{shift}%, 0, 0);
       -moz-transform: translate3d(#{shift}%, 0, 0);
        -ms-transform: translate3d(#{shift}%, 0, 0);
         -o-transform: translate3d(#{shift}%, 0, 0);
            transform: translate3d(#{shift}%, 0, 0);
    """.htmlSafe()
  ).property('currentSlideIndex', 'slides.length')

  ###
  # Предотвращает нежелательный скролл scrollable-sections
  ###
  attachFixScroll: (->
    @$().on 'scroll', ->
      Em.$(@).get(0).scrollLeft = 0
      Em.$(@).get(0).scrollTop  = 0
  ).on('didInsertElement')

  detachFixScroll: (->
    @$().off('scroll')
  ).on('willDestroyElement')

  ###
  # Индекс текущего слайда
  ###
  currentSlideIndex: 0
  currentSlideClass: (->
    "slide-#{@get('currentSlideIndex')}"
  ).property('currentSlideIndex')

  ###
  # Количество слайдов
  ###
  slidesCountBinding: 'slides.length'
  slidesCountClass: (->
    "slides-count-#{@get('slidesCount')}"
  ).property('slidesCount')

  currentSlideName: ((key, value) ->
    slides = @get('slides')
    index  = @get('currentSlideIndex')

    return unless Em.isArray(slides)

    # setter
    if arguments.length > 1
      slide = slides.find (s) =>
        s.get('name') is value

      if slide
        @set('currentSlideIndex', slide.get('sectionIndex'))

    # getter
    section = slides.find (s) =>
      s.get('sectionIndex') is index

    section?.get('name')
  ).property(
    'currentSlideIndex',
    'slides.[]')

  flushSlides: (->
    @set('slides', [])
  ).on('init')


App.SmSlideableSectionComponent = Em.Component.extend
  classNames: [ 'sm-slideable-section' ]

  sectionIndex: (->
    @$().index()
  ).property().volatile()

  register: (->
    @get('parentView.slides').pushObject(@)
  ).on('didInsertElement')

  unregister: (->
    @get('parentView.slides').removeObject(@)
  ).on('willDestroyElement')
